import clsx from 'clsx';
import styles from './CookieSettings.module.scss?module';

const CookieSettings = () => {
  function handleOpenCookieSettings(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    event.preventDefault();

    if (typeof window !== 'undefined' && window.Cookiebot) {
      window.Cookiebot.renew();
    }
  }

  return (
    <button
      className={clsx(styles.CookieSettings)}
      aria-label="Adjust cookie settings"
      onClick={handleOpenCookieSettings}
    >
      Cookie Settings
    </button>
  );
};

export default CookieSettings;
